import ClaimListing, { ClaimColumns, ClaimFilters, ClaimStatusFilter_Empty } from '../shared/ClaimListing/ClaimListing';

export default function NoticeReceivedTab() {
  return (
    <ClaimListing
      defaultRowsPerPage={50}
      columns={[
        ClaimColumns.endDate,
        ClaimColumns.insuredName,
        ClaimColumns.reinsuranceYear,
        ClaimColumns.policyNumber,
        ClaimColumns.sce,
        ClaimColumns.state,
        ClaimColumns.effectiveDate,
        ClaimColumns.crop,
      ]}
      filters={[ClaimFilters.insuredNameSearch, ClaimFilters.endDate]}
      additionalPayload={{
        status: ClaimStatusFilter_Empty,
        recentlyEnded: true,
        specialSort: 'EndDate,InsuredName',
      }}
      columnsSortable={false}
      includeExport={false}
    />
  );
}
